import { useSidebarSectionCollapsed } from "@app/hooks/useSidebarSectionCollapsed";

const localStorageKeyPrefix = "sidebarProjectExpanded";

// Projects start collapsed, so the persisted flag records the opened state
// rather than the collapsed one. Persisting it keeps a project open across the
// layout remount between a project page and one of its conversations.
export const useSidebarProjectExpanded = (podId: string) => {
  const { isCollapsed, setCollapsed } = useSidebarSectionCollapsed(
    `${localStorageKeyPrefix}.${podId}`
  );

  return {
    isProjectExpanded: isCollapsed,
    setProjectExpanded: setCollapsed,
  };
};
